import { render, staticRenderFns } from "./digitalIntelligence.vue?vue&type=template&id=6b1ba6f7&scoped=true&"
import script from "./digitalIntelligence.vue?vue&type=script&lang=js&"
export * from "./digitalIntelligence.vue?vue&type=script&lang=js&"
import style0 from "./digitalIntelligence.vue?vue&type=style&index=0&id=6b1ba6f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ba6f7",
  null
  
)

export default component.exports